exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".floaty-label[data-v-7d2cf0c9]{top:15px}.special-hp[data-v-7d2cf0c9]{display:none}#login-modal a.forgot-pw[data-v-7d2cf0c9]{display:block;text-align:right}#login-modal .button.sfc-blue[data-v-7d2cf0c9]{width:100%;max-width:300px;margin:15px auto;display:block}", ""]);

